import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Calculator, Loader2, Plus } from "lucide-react";
import { num, shortDate } from "@/lib/format";
import { SimEditor } from "@/components/planning/SimEditor";

const pieces = (s) => s.articles.reduce((t, a) => t + a.colors.reduce((x, c) => x + (c.quantity || 0), 0), 0);

export const SimulationsSection = ({ season, sheets, search }) => {
  const [editing, setEditing] = useState(null);
  const { data: sims = [], isLoading } = useQuery({ queryKey: ["simulations", season], queryFn: async () => (await api.get("/simulations", { params: { season } })).data });
  const w = search.toLowerCase();
  const shown = sims.filter((s) => [s.name, ...s.articles.map((a) => a.name)].join(" ").toLowerCase().includes(w));
  return (
    <div data-testid="simulations-section">
      <div className="mb-4 flex flex-wrap items-center justify-between gap-2">
        <p className="text-xs text-muted-foreground">Stima di quanto tessuto e accessori servono per gli articoli che pensi di produrre, confrontata con magazzino e ordini in arrivo. Non scala nulla dal magazzino.</p>
        <Button onClick={() => setEditing({ season: season === "tutti" ? undefined : season, name: "" })} disabled={season === "tutti"} data-testid="new-sim-btn"><Plus className="mr-2 h-4 w-4" />Nuova simulazione</Button>
      </div>
      {isLoading && <div className="flex h-40 items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-primary" /></div>}
      {!isLoading && !shown.length && <p className="flex flex-col items-center gap-2 py-16 text-center text-sm text-muted-foreground" data-testid="sims-empty"><Calculator className="h-6 w-6" />Nessuna simulazione per questa stagione.</p>}
      <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
        {shown.map((s) => (
          <Card key={s.id} className="cursor-pointer space-y-1 p-4 transition-colors hover:border-primary/50" onClick={() => setEditing(s)} data-testid={`sim-card-${s.id}`}>
            <p className="font-display font-semibold">{s.name}</p>
            <p className="text-xs text-muted-foreground">{s.articles.length} articoli · {num(pieces(s))} capi · aggiornata {shortDate(s.updated_at)}</p>
            <p className="truncate text-xs text-muted-foreground">{s.articles.map((a) => a.name).filter(Boolean).join(" · ")}</p>
          </Card>
        ))}
      </div>
      {editing && <SimEditor sim={editing} sheets={sheets} onClose={() => setEditing(null)} />}
    </div>
  );
};
